<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">测试账号</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>类型：</label>
          <el-select v-model="state" placeholder="请选择" size="mini" style="width: 7em;">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <el-input type="text" clearable placeholder="请输入手机号" maxlength="11" v-model="phone" style="width: 16em;"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="success" icon="Plus" @click="add" :loading="addLoading"> 添加 </ElButtons>
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
        >
          <el-table-column property="createTime" label="创建时间"/>
          <el-table-column property="phone" label="手机号"></el-table-column>
          <el-table-column property="" label="操作">
            <template #default="scope">
              <el-button type="danger" size="small" @click="del(scope.$index)">删除</el-button>
              <el-button type="primary" v-if="scope.row.state == 0" size="small" @click="updateState(scope.$index, 1)" v-loading="pageDataList[scope.$index].updateLoading">设为审核账号</el-button>
              <el-button type="warning" v-if="scope.row.state == 1" size="small" @click="updateState(scope.$index, 0)" v-loading="pageDataList[scope.$index].updateLoading">取消审核账号</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getFormData, postFormData} from "@/api/api";
import {getTestAccountList, addTestAccount, delTestAccount,  updateAccountState} from "@/api/url";
import { phoneReg } from '../../assets/shared/reg-constant'

export default {
  name: "TestAccount",
  data() {
    return {
      phone: '',
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      stateArray: [
        { label: '不限', value: -1},
        { label: '测试账号', value: 0},
        { label: '审核账号', value: 1},
      ],
      state: -1,

      searchLoading: false,
      listLoading: false,
      addLoading:false,
    }
  },
  methods: {
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchValue'] = this.phone;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getTestAccountList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    // 添加
    add() {
      if(!phoneReg.test(this.phone)) {
        this.$message({
          showClose: true,
          duration: 1500,
          message: '请填写正确手机号',
          type: 'warning'
        })
        return;
      }
      this.addLoading = true;
      let param = {};
      param['phone'] = this.phone;
      postFormData(addTestAccount, param).then((data) => {
        let {msg,code} = data;
        if(code == 200) {
          this.phone = '';
          this.getPage();
        }else{
          this.$message({
            showClose: true,
            duration: 1500,
            message: msg,
            type: 'warning'
          })
        }
        this.addLoading = false;
      })
          .catch((response) => {
            this.addLoading = false;
          })
    },

    // 删除
    del(idx) {
      this.$confirm('确认删除【' + this.pageDataList[idx]['phone'] + '】账号？').then(() => {
        let param = {};
        param['id'] = this.pageDataList[idx]['id'];
        postFormData(delTestAccount, param).then((data) => {
          let {code, msg} = data;
          if(code == 200){
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.pageDataList.splice(idx,1)
          } else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
        }).catch(() => {})
      }).catch(() => {})
    },

    // 审核账号
    updateState(idx, state) {
      this.$confirm('确认' + (state == 1?'设置':'取消') +  '【' + this.pageDataList[idx]['phone'] + '】审核账号？').then(() => {
        this.pageDataList[idx]['updateLoading'] = true;
        // this.$set(this.pageDataList, idx, this.pageDataList[idx]);
        let param = {};
        param['id'] = this.pageDataList[idx]['id'];
        param['state'] = state;
        postFormData(updateAccountState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200){
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.pageDataList[idx]['state'] = state
          } else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          this.pageDataList[idx]['updateLoading'] = false;
        })
            .catch((err) => {
              this.pageDataList[idx]['updateLoading'] = false;
            })
      })
          .catch(() => {

          })
    }

  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
